import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getValuationBreakpointSummary } from '@dealstack/frontend/shared/dataExchange/services/valuations.service';
import { buildSecurityComponentMap } from '@dealstack/frontend/app/pages/Valuations/views/BreakpointSummary/buildSecurityComponentMap';
import { VALUATION_BREAKPOINT_SUMMARY_QUERY_KEY } from '@dealstack/frontend/app/pages/Valuations/queries/queryKeys';
import { useSecurityValueOverrideMutations } from '@dealstack/frontend/app/pages/Valuations/queries/useSecurityValueOverrideMutations';

export function useBreakpointSummaryQuery(
	dealId: string | undefined,
	valuationId: string | undefined,
	personId: string | undefined,
	mipId: string | undefined,
	resultId: string | undefined,
	reloadSummary: () => Promise<unknown>
) {
	const breakpointQuery = useQuery({
		queryKey: [
			VALUATION_BREAKPOINT_SUMMARY_QUERY_KEY,
			dealId ?? '',
			valuationId ?? '',
			resultId ?? '',
			personId ?? '',
			mipId ?? '',
		],
		queryFn: () =>
			getValuationBreakpointSummary({
				valuationId: valuationId ?? '',
				dealId: dealId ?? '',
				personId: personId ?? '',
				mipId,
				resultId: resultId ?? '',
			}),
		enabled: !!resultId && !!personId,
		retry: false,
	});

	const breakpointSummaryData = breakpointQuery.data?.payload?.result ?? undefined;

	const securityComponentMap = useMemo(
		() => buildSecurityComponentMap(breakpointSummaryData),
		[breakpointSummaryData]
	);

	const overrideMutations = useSecurityValueOverrideMutations({
		dealId,
		valuationId,
		reloadSummary,
	});

	return {
		breakpointSummaryData,
		isBreakpointSummaryFirstLoad: !breakpointQuery.data && breakpointQuery.isLoading,
		isBreakpointSummaryLoading: breakpointQuery.isFetching,
		securityComponentMap,
		...overrideMutations,
	};
}
